//地址定义

import UltMeta, { Meta } from "./UltMeta/index";

class IsDefault extends UltMeta {
    NOT_DEFAULT = new Meta(0, "非默认");
    DEFAULT = new Meta(1, "默认");
}

export const IS_DEFAULT = new IsDefault();
